import Entity from './../entity'

export default class LostFoundItem extends Entity<number>{
    type:string;
    status:Date;
    note:string;
    locationId :number;
    productId:number;
    qty:number;
    expiredDate:Date;
    bestBeforeDate:Date;
    manufatureDate :Date;
    warehouseCode:string;
    resolvedDate:Date;
    confirmedQty :number;
    typeName:string;
    statusName:string;
    locationCode:string;
    sku:string;
    productName:string;
    assetTypeName :string;
    conditionTypeName:string;
    resolvedByName:string;
    creatorUserName:string;
    serialNos:Array<string>;

    isResolveLost: boolean;
    pickListCode: string;
    pickListUrl : string;
    workOrderTypeName: string;
}